<template>
  <div class="info-card company-card">
    <div class="info-header">
      <slot name="icon">
        <feather-icon
          icon="HomeIcon"
          size="20"
          class="mr-2"
        />
      </slot>
      <h5 class="mb-0">
        {{ headerTitle }}
      </h5>
    </div>
    <div class="info-content">
      <b-row>
        <b-col
          cols="12"
          :md="layout === 'horizontal' ? 6 : 12"
        >
          <div class="info-item">
            <strong>{{ company.name }}</strong>
            <span class="info-subtitle">{{ displayTagline }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">Matricule fiscale:</span>
            <span>{{ displayTaxId }}</span>
          </div>
        </b-col>
        <b-col
          cols="12"
          :md="layout === 'horizontal' ? 6 : 12"
        >
          <div class="info-item">
            <span class="info-label">Adresse:</span>
            <span>{{ company.address }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">Téléphone:</span>
            <span>{{ displayPhone }}</span>
          </div>
          <div
            v-if="showEmail && company.email"
            class="info-item"
          >
            <span class="info-label">Email:</span>
            <span>{{ company.email }}</span>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'

export default {
  name: 'DocumentCompanyInfo',
  components: {
    BRow,
    BCol,
  },
  props: {
    company: {
      type: Object,
      required: true,
    },
    headerTitle: {
      type: String,
      default: 'Notre Société',
    },
    maskTaxId: {
      type: Boolean,
      default: false,
    },
    showEmail: {
      type: Boolean,
      default: false,
    },
    showSecondPhone: {
      type: Boolean,
      default: false,
    },
    layout: {
      type: String,
      default: 'horizontal', // 'horizontal' or 'vertical'
      validator: value => ['horizontal', 'vertical'].includes(value),
    },
    customTagline: {
      type: String,
      default: null,
    },
  },
  computed: {
    displayTaxId() {
      if (!this.company.tax_identification_number) return ''
      if (this.maskTaxId) {
        return `***${this.company.tax_identification_number.slice(3)}`
      }
      return this.company.tax_identification_number
    },
    displayTagline() {
      if (this.customTagline) return this.customTagline
      return this.company.tagline || 'Société de livraison des colis'
    },
    displayPhone() {
      if (this.showSecondPhone && this.company.phone2) {
        return `${this.company.phone1} / ${this.company.phone2}`
      }
      return this.company.phone1
    },
  },
}
</script>

<style scoped>
.company-card {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 1rem;
  margin-bottom: 1rem;
}

.info-header {
  display: flex;
  align-items: center;
  margin-bottom: 0.75rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #e9ecef;
}

.info-header h5 {
  font-weight: 600;
  color: #495057;
}

.info-content {
  font-size: 0.9rem;
}

.info-item {
  margin-bottom: 0.5rem;
}

.info-item strong {
  display: block;
  font-size: 1rem;
  color: #212529;
}

.info-subtitle {
  display: block;
  font-size: 0.85rem;
  color: #6c757d;
  font-style: italic;
}

.info-label {
  font-weight: 500;
  color: #495057;
  margin-right: 0.5rem;
}

@media print {
  .company-card {
    background: #fff;
    border: 1px solid #dee2e6;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }
}
</style>
